export { default as correction } from './correction';
export { eraseInsideFreehand, eraseOutsideFreehand } from './eraseFreehand';
export {
  eraseInsideRectangle,
  eraseOutsideRectangle,
} from './eraseRectangle.js';
export { fillInsideFreehand, fillOutsideFreehand } from './fillFreehand';
export { fillInsideRectangle, fillOutsideRectangle } from './fillRectangle';
export { fillInsideCircle, fillOutsideCircle } from './fillCircle';
export { eraseInsideCircle, eraseOutsideCircle } from './eraseCircle';
